import Vue from 'vue';
import Vuex from 'vuex';

import alerts from './modules/alerts';
import cards from './modules/cards';
import classMode from './modules/classMode';
import evaluate from './modules/evaluate';
import quiz from './modules/quiz';
import ranking from './modules/ranking';
import rondo from './modules/rondo';
import score from './modules/score';
import search from './modules/search';
import session from './modules/session';
import settings from './modules/settings';
import stats from './modules/stat';
import tutorial from './modules/tutorial';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alerts,
    cards,
    classMode,
    evaluate,
    quiz,
    ranking,
    rondo,
    score,
    search,
    session,
    settings,
    stats,
    tutorial,
  },
});
